import React, { useEffect } from 'react'
import { getAppName } from '../../../AppType';

interface Props {
  /**
   * Use either this or children.
   */
  title?: string | string[];
  suffix?: string;
  children?: any;
}

const defaultSeparator = " - ";

type DocumentTitleWindow = typeof window & { originalDocumentTitle: string; };

/**
 * @returns The most recent document title set by an instance of the `DocumentTitle` component.
 */
export function getOriginalDocumentTitle() {
  return (window as DocumentTitleWindow).originalDocumentTitle || document.title;//as
}

/**
 * Sets `document.title` on mount.
 */
export const DocumentTitle: React.FC<Props> = ({ children, title, suffix = getAppName() }) => {
  useEffect(() => {
    let titleComponents = children;
    if (typeof titleComponents !== "string") {
      titleComponents = title;
    }

    const isArray = Array.isArray(titleComponents)
    if (typeof titleComponents === "string" || isArray) {
      document.title = (window as DocumentTitleWindow).originalDocumentTitle = [...(isArray ? titleComponents : [titleComponents]), suffix]
        .filter(e => !!e).join(defaultSeparator);
    }
  }, [title, children]);

  return null;
}